import {
  DataPolicyActorCollaborator,
  DataPolicyGroupCollaborator,
  SchemaPolicyActorCollaborator,
  SchemaPolicyGroupCollaborator,
} from 'auth/PermissionConstants';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import {ORGANIZATION} from 'test/fixtures/parties/OrganizationFixtures';
import {TEAM, TEAM_2} from 'test/fixtures/parties/TeamFixtures';
import {USER, USER_2} from 'test/fixtures/parties/UserFixtures';

import {READ_POLICY, SCHEMA_READ_POLICY, SCHEMA_CREATE_POLICY, WRITE_POLICY} from './PolicyFixtures';

export const USER_COLLABORATOR: DataPolicyActorCollaborator = {
  id: USER.id,
  handle: USER.handle,
  name: USER.name,
  dataPolicyId: READ_POLICY.id,
  type: ModelTypeConstants.USER,
};

export const USER_2_COLLABORATOR: DataPolicyActorCollaborator = {
  id: USER_2.id,
  handle: USER_2.handle,
  name: USER_2.name,
  dataPolicyId: READ_POLICY.id,
  type: ModelTypeConstants.USER,
};

export const USER_COLLABORATOR_WITH_NAME: DataPolicyActorCollaborator = {
  id: USER.id,
  handle: USER.handle,
  name: USER.name,
  dataPolicyId: READ_POLICY.id,
  type: ModelTypeConstants.USER,
};

export const USER_AUDITOR: DataPolicyActorCollaborator = {
  id: USER.id,
  handle: USER.handle,
  name: USER.name,
  dataPolicyId: READ_POLICY.id,
  type: ModelTypeConstants.USER,
  auditor: true,
};

export const TEAM_COLLABORATOR: DataPolicyGroupCollaborator = {
  id: TEAM.id,
  handle: TEAM.handle,
  name: TEAM.name,
  memberDataPolicyId: READ_POLICY.id,
  adminDataPolicyId: null,
  type: ModelTypeConstants.TEAM,
};

export const TEAM_COLLABORATOR_2: DataPolicyGroupCollaborator = {
  id: TEAM_2.id,
  handle: TEAM_2.handle,
  name: TEAM_2.name,
  memberDataPolicyId: READ_POLICY.id,
  adminDataPolicyId: null,
  type: ModelTypeConstants.TEAM,
};

export const TEAM_AUDITOR: DataPolicyGroupCollaborator = {
  id: TEAM.id,
  handle: TEAM.handle,
  name: TEAM.name,
  memberDataPolicyId: READ_POLICY.id,
  adminDataPolicyId: null,
  type: ModelTypeConstants.TEAM,
  auditor: true,
};

export const ORG_COLLABORATOR: DataPolicyGroupCollaborator = {
  id: ORGANIZATION.id,
  handle: ORGANIZATION.handle,
  name: ORGANIZATION.name,
  memberDataPolicyId: READ_POLICY.id,
  adminDataPolicyId: WRITE_POLICY.id,
  type: ModelTypeConstants.ORGANIZATION,
};

export const USER_SCHEMA_COLLABORATOR: SchemaPolicyActorCollaborator = {
  id: USER.id,
  handle: USER.handle,
  name: USER.name,
  schemaPolicyId: SCHEMA_READ_POLICY.id,
  type: ModelTypeConstants.USER,
};

export const USER_2_SCHEMA_COLLABORATOR: SchemaPolicyActorCollaborator = {
  id: USER_2.id,
  handle: USER_2.handle,
  name: USER_2.name,
  schemaPolicyId: SCHEMA_READ_POLICY.id,
  type: ModelTypeConstants.USER,
};

export const TEAM_SCHEMA_COLLABORATOR: SchemaPolicyGroupCollaborator = {
  id: TEAM.id,
  handle: TEAM.handle,
  name: TEAM.name,
  memberSchemaPolicyId: SCHEMA_READ_POLICY.id,
  adminSchemaPolicyId: SCHEMA_CREATE_POLICY.id,
  type: ModelTypeConstants.TEAM,
};

export const ORG_SCHEMA_COLLABORATOR: SchemaPolicyGroupCollaborator = {
  id: ORGANIZATION.id,
  handle: ORGANIZATION.handle,
  name: ORGANIZATION.name,
  memberSchemaPolicyId: SCHEMA_READ_POLICY.id,
  adminSchemaPolicyId: null,
  type: ModelTypeConstants.ORGANIZATION,
};
